/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const StarLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m12 18.26-7.05 3.95 1.57-7.93L.6 8.79l8.02-.95L12.01.5l3.38 7.34 8.02.95-5.93 5.49 1.57 7.93zm0-2.3 4.25 2.39-.95-4.78 3.57-3.3-4.83-.58L12 5.28 9.96 9.69l-4.83.58 3.57 3.3-.95 4.78z" />
  </Icon>
);
